<li dropdown >
  <a dropdown-toggle class="report_dropdown" data-toggle="dropdown" href="javascript:void(0)"> Output Data</a>
  <ul class="dropdown-menu" span *ngIf="role!= 'student'">
    <li class="dropdown-submenu">
      <a class="submenu" href="javascript:void(0)"> Start Quarter</a>
      <ul class="dropdown-menu" *ngIf="qtrs!= undefined" class='report-menu'>
        <li><a [routerLink]="['/report/viewer']" [queryParams]="{r: 'pdf', start:'undefined', token: token }" target='_blank'>Printable PDF of Starting Position</a></li>
        <li><a [routerLink]="['/report/viewer']" [queryParams]="{r: 'decision', start:'undefined', token: token }" target='_blank'>Decision Forms</a></li>
        <li *ngFor="let r of b_reports let index = index">
          <a [routerLink]="['/report/viewer']" [queryParams]="{ r: r,start:'undefined',q_index:0, token: token}" target='_blank'>{{r}}</a>
          <!-- <a href="javascript:void(0)">{{report}}</a> -->
        </li>
      </ul>
    </li>
    <li class="dropdown-submenu" *ngIf="qtrs.length>0">
      <a class="submenu" href="javascript:void(0)"> Instructor Reports </a>
      <ul class="dropdown-menu">
        <li class="dropdown-submenu" *ngFor="let q of qtrs; let qindex = index"><a class="secondsubmenu" href="javascript:void(0)">{{construct_quarter_name(q)}}</a>
          <ul class="dropdown-menu" class='report-menu'>
            <span *ngFor="let c of communities; let cindex = index">
              <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, r: 'instructor_'+c, q: q, token: token }" target='_blank'>Printable PDF of Instructor Report {{c}} </a> </li></span>
              <span *ngFor="let c of communities; let cindex = index">
                <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c,r: 'community', q: q, t:'Team '+c+'1', token: token }" target='_blank'>Excel Worksheet of Instructor {{c}} </a></li>
              </span>
            <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c,r: 'instructor', q: q, token: token }" target='_blank'>Print All PDF Reports </a></li>
            <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c,r: 'decisions', q: q, token: token }" target='_blank'> Print All Decision Forms</a></li>
            <span *ngFor="let c of communities; let cindex = index">
              <span *ngFor="let r of c_arr[qindex]">
                <span *ngFor="let t of teams[cindex]; let tindex = index">
                  <!-- <li><a href="javascript:void(0)">{{c}}-{{r}} {{tindex + 1}} </a></li> -->
                  <a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: c+'-'+r+'-'+(tindex+1) , q: q, instr: 'undefined', q_index:qindex, token: token }" target='_blank'>{{c}}-{{r}} {{tindex + 1}}</a>
                </span>
              </span>
              <span *ngFor="let cr of ins_arr[qindex]">
                <a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: 'Team '+c+'1',r: c+'-'+cr, q: q, instr: 'undefined', q_index:qindex, token: token }" target='_blank'>{{c}}-{{cr}}</a>
              </span>
            </span>
          </ul>
        </li>
      </ul>
    </li>

      <!--team reports -->
      <span *ngIf="qtrs.length>0">
        <span *ngFor="let c of communities; let cindex = index">
            <li class="dropdown-submenu" *ngFor="let t of teams[cindex]">
              <a class="submenu" href="javascript:void(0)">{{t}}</a>
              <ul class="dropdown-menu">
                <span *ngFor="let q of qtrs; let rindex=index">
                  <li class="dropdown-submenu"><a class="secondsubmenu" href="javascript:void(0)">{{construct_quarter_name(q)}}</a>
                    <ul class="dropdown-menu" class='report-menu'>
                      <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: 'pdf', q: q, token: token }" target='_blank'>Printable Report of PDF</a></li>
                      <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: 'excel', q: q, token: token }" target='_blank'>Excel Workbook</a></li>
                      <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: 'decision', q: q, token: token }" target='_blank'>Decision Forms</a></li>
                      <li *ngFor="let b_br of b_r[rindex]">
                        <a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: b_br, q: q ,q_index:rindex, token: token}" target='_blank'>{{b_br}}</a>
                      <!-- <a href="http://localhost:3000/reports?c={{c}}&t={{t}}&r={{r}}&q={{q}}" target='_blank'> {{r}}</a> -->
                      </li>
                      <li *ngFor="let c_r of c_r[rindex]">
                          <a [routerLink]="['/report/viewer']" [queryParams]="{ c: c, t: t,r: c_r, q: q,q_index:rindex, token: token }" target='_blank'>{{c_r}}</a>
                          <!-- <a href="http://localhost:3000/reports?c={{c}}&t={{t}}&r={{r}}&q={{q}}" target='_blank'> {{r}}</a> -->
                      </li>
                    </ul>
                  </li>
                </span>
              </ul>
            </li>
        </span>
      </span>
  </ul>

  <ul class="dropdown-menu" span *ngIf="role== 'student'">
    <li class="dropdown-submenu">
      <a class="submenu" href="javascript:void(0)"> Bank Reports</a>
      <ul class="dropdown-menu">
        <li class="dropdown-submenu">
          <a class="secondsubmenu" href="javascript:void(0)"> Start Quarter</a>
          <ul class="dropdown-menu" *ngIf="qtrs!= undefined" class='report-menu'>
            <li><a [routerLink]="['/report/viewer']" [queryParams]="{r: 'pdf', start:'undefined', token: token }" target='_blank'>Printable PDF of Starting Position</a></li>
            <!-- <li><a [routerLink]="['/report/viewer']" [queryParams]="{r: 'decision', start:start, token: token }" target='_blank'>Decision Forms</a></li> -->
            <li *ngFor="let r of b_reports let index = index">
              <a [routerLink]="['/report/viewer']" [queryParams]="{ r: r,start:'undefined',q_index:rindex, token: token }" target='_blank'>{{r}}</a>
              <!-- <a href="javascript:void(0)">{{report}}</a> -->
            </li>
          </ul>
        </li>
          <!--team reports -->
        <span *ngIf="qtrs.length>0">
          <span *ngFor="let q of qtrs; let rindex=index">
            <li class="dropdown-submenu"><a class="secondsubmenu" href="javascript:void(0)">{{construct_quarter_name(q)}}</a>
              <ul class="dropdown-menu" class='report-menu'>
                <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: communities, t: teams,r: 'pdf', q: q, token: token }" target='_blank'>Printable Report of PDF</a></li>
                <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: communities, t: teams,r: 'excel', q: q, token: token }" target='_blank'>Excel Workbook</a></li>
                <!-- <li><a [routerLink]="['/report/viewer']" [queryParams]="{ c: communities, t: teams,r: 'decision', q: q, token: token }" target='_blank'>Decision Forms</a></li> -->
                <li *ngFor="let r of bank_reports[rindex]">
                  <a [routerLink]="['/report/viewer']" [queryParams]="{ c: communities, t: teams, s:'student',r: r, q: q, q_index:rindex, token: token }" target='_blank'>{{r}}</a>
                  <!-- <a href="http://localhost:3000/reports?c={{c}}&t={{t}}&r={{r}}&q={{q}}" target='_blank'> {{r}}</a> -->
                </li>
              </ul>
            </li>
          </span>
        </span>
      </ul>
    </li>
  </ul>
</li>